export default "__VITE_ASSET__qQIy0u88__"